import { useState } from 'react';
import { useEmitter } from 'hooks/useEmitter';
import Boto from 'components/3catinfo/Boto';
import Slider from 'components/3catinfo/Slider';
import __isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';
import styles from './tabselector.module.scss';

const TabSelector = (props) => {
    const {
        tabId,
        items,
        estils,
        estilBotons = 'default',
        eventTabInicial = false,
        tabInicial = 0,
        spaceBetween = 8,
        className,
        fons,
        selectedIndex,
        onChange
    } = props;
    const [selected, setSelected] = useState(tabInicial);
    const { emit, emitOnLoad } = useEmitter();
    const arrayEstils = estils?.split(' ') || [];
    const isControlled = typeof selectedIndex === 'number';
    const currentSelected = isControlled ? selectedIndex : selected;

    if (eventTabInicial && !__isEmpty(items) && Array.isArray(items)) {
        emitOnLoad(tabId, items[currentSelected]?.valor);
    }

    const stylesTabSelector = clsx({
        [styles.tabSelector]: true,
        ...arrayEstils.reduce((acc, currentStyle) => {
            acc[styles[currentStyle]] = !__isEmpty(currentStyle);
            return acc;
        }, {}),
        [styles[fons]]: !!fons,
        [[className]]: !!className
    });

    if (__isEmpty(items) || !Array.isArray(items)) return <></>;
    return (
        <div className={stylesTabSelector}>
            <div className={styles.contentButtons}>
                <Slider
                    tipus='menu'
                    seccio={`tab-selector-${selected}`}
                    spaceBetween={spaceBetween}
                    estilFletxes='menuTabSelector'
                    fons={fons}
                >
                    {items.map((item, i) => {
                        const isSelect = currentSelected === i;
                        const stylesBoto = clsx({
                            [styles.boto]: true,
                            [styles[estilBotons]]: !!estilBotons,
                            [styles.selected]: isSelect
                        });
                        return (
                            <Boto
                                key={`boto-tab-selector-${i}`}
                                tag='button'
                                text={item.boto}
                                className={stylesBoto}
                                estil='grey'
                                ariaPressed={isSelect}
                                onClick={() => {
                                    if (!isControlled) {
                                        setSelected(i);
                                    }

                                    if (onChange) {
                                        onChange(i, item.valor);
                                        return;
                                    }

                                    emit(tabId, item.valor);
                                }}
                                fons={fons}
                            />
                        );
                    })}
                </Slider>
            </div>
        </div>
    );
};

export default TabSelector;
